import { Redirect, Route, Switch } from 'react-router-dom';

import SystemStatus from '../components/SystemStatus/SystemStatus';
import SystemNotifications from '../components/Notifications/SystemNotifications';
import SystemSettings from '../components/SystemSettings/SystemSettings';
import Forbidden from './pages/Forbidden/Forbidden';
import SoftwareUpdatesWithFeature from '../components/SoftwareUpdates/SoftwareUpdatesWithFeature';
import Logout from '../components/Logout/Logout';
import NotFound from './pages/NotFound/NotFound';
import { LogicalRoute } from './helpers/LogicalRoute';

export default function SaasSupportRestrictedRoutings() {
    return (
        <Switch>
            <Route exact path="/">
                <Redirect exact from="/" to="/Settings" />
            </Route>
            <Route path="/Logout" component={Logout} />
            <Route path="/Settings" component={SystemSettings} />
            <Route path="/SystemStatus" component={SystemStatus} />
            <Route path="/SystemEvents" component={SystemNotifications} />
            <LogicalRoute path="/SoftwareUpdates" component={SoftwareUpdatesWithFeature} />
            <Route path="/Forbidden" component={Forbidden} />
            <Route path="*" component={NotFound} />
        </Switch>
    );
}
